import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { NAV } from "../data/content";
import { ChevronDown, Menu, X } from "lucide-react";

function isActiveTopLevel(item, pathname) {
  if (item.path === pathname) return true;
  if (item.children?.some((c) => pathname.startsWith(c.path.split("/")[1] ? "/" + c.path.split("/")[1] : c.path))) {
    // crude check: shares first segment
    const seg = "/" + (item.children[0].path.split("/")[1] || "");
    return pathname.startsWith(seg);
  }
  return false;
}

export default function NavBar() {
  const [openIdx, setOpenIdx] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="border-t border-b border-[#d6dcb6] bg-white relative">
      {/* Desktop */}
      <div className="hidden lg:flex items-center justify-center gap-1 px-4 py-3 relative">
        {NAV.map((item, idx) => {
          const active = isActiveTopLevel(item, location.pathname);
          return (
            <div
              key={item.label}
              className="relative"
              onMouseEnter={() => setOpenIdx(idx)}
              onMouseLeave={() => setOpenIdx(null)}
            >
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center gap-1 px-3 py-2 text-[0.95rem] font-display tracking-wide transition-colors ${
                    isActive || active
                      ? "text-[#5b6a37] underline underline-offset-4"
                      : "text-[#7d8e54] hover:text-[#5b6a37]"
                  }`
                }
              >
                {item.label}
                {item.children && <ChevronDown className="w-3 h-3 opacity-60" />}
              </NavLink>
              {item.children && openIdx === idx && (
                <div className="nn-subnav">
                  {item.children.map((c) => (
                    <NavLink
                      key={c.path}
                      to={c.path}
                      className={({ isActive }) =>
                        `block px-4 py-2 text-sm border-b border-[#eef0e0] last:border-0 ${
                          isActive
                            ? "text-[#5b6a37] bg-[#f6f8ec]"
                            : "text-[#7d8e54] hover:bg-[#f6f8ec] hover:text-[#5b6a37]"
                        }`
                      }
                    >
                      {c.label}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Mobile */}
      <div className="lg:hidden flex items-center justify-between px-4 py-3">
        <span className="font-display text-[#7d8e54] text-lg">Menu</span>
        <button
          onClick={() => setMobileOpen((v) => !v)}
          className="text-[#7d8e54] p-1 rounded hover:bg-[#f6f8ec]"
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X /> : <Menu />}
        </button>
      </div>
      {mobileOpen && (
        <div className="lg:hidden border-t border-[#d6dcb6] bg-white">
          {NAV.map((item) => (
            <div key={item.label} className="border-b border-[#eef0e0]">
              <NavLink
                to={item.path}
                onClick={() => setMobileOpen(false)}
                className="block px-4 py-3 text-[#7d8e54] font-display"
              >
                {item.label}
              </NavLink>
              {item.children && (
                <div className="pb-2">
                  {item.children.map((c) => (
                    <NavLink
                      key={c.path}
                      to={c.path}
                      onClick={() => setMobileOpen(false)}
                      className="block px-8 py-1.5 text-sm text-[#7d8e54]"
                    >
                      — {c.label}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </nav>
  );
}
